module.exports = __webpack_public_path__ + "static/media/copy-link.98123df3.png";